const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

document.addEventListener('DOMContentLoaded', function() {
  // Store selected filters
  let selectedFilters = [];

  const filterButtons = document.querySelectorAll('.filter-btn');

  // Add event listeners for filter button clicks
  filterButtons.forEach((button) => {
    button.addEventListener('click', function() {
      const tag = this.getAttribute('data-tag');
      const filterType = this.classList.contains('activity-btn') ? 'activity' :
                          this.classList.contains('weight-btn') ? 'weight' :
                          'length';
      
      // Deselect other filters within the same category
      deselectOtherFilters(filterType, tag);

      // Toggle the current filter selection
      if (!selectedFilters.includes(tag)) {
        selectedFilters.push(tag);
        button.classList.add('selected'); // Optional: Add visual feedback for selection
      } else {
        selectedFilters = selectedFilters.filter(filter => filter !== tag);
        button.classList.remove('selected'); // Optional: Remove selection feedback
      }

      // Update product visibility based on the selected filters
      filterProducts();
    });
  });

  // Function to deselect other filters within the same category
  function deselectOtherFilters(filterType, selectedTag) {
    const buttonsInCategory = document.querySelectorAll(`.${filterType}-btn`);

    buttonsInCategory.forEach((button) => {
      const tag = button.getAttribute('data-tag');
      
      // Deselect buttons that are already selected but are not the clicked one
      if (button.classList.contains('selected') && tag !== selectedTag) {
        button.classList.remove('selected');
        selectedFilters = selectedFilters.filter(filter => filter !== tag); // Remove from selected filters
      }
    });
  }

  // Function to filter products based on selected filters
  function filterProducts() {
    const products = document.querySelectorAll('.product');
    
    products.forEach((product) => {
      const productTags = product.getAttribute('data-tags').split(',');  // Get the tags associated with the product

      // Check if the product has all selected tags
      const matchesAllFilters = selectedFilters.every(filter => productTags.includes(filter));

      if (matchesAllFilters) {
        product.style.display = 'block'; // Show product if it matches all filters
      } else {
        product.style.display = 'none'; // Hide product if it doesn't match all filters
      }
    });
  }

  // Clear all filters
  document.getElementById('clear-filters').addEventListener('click', function() {
    selectedFilters = [];  // Clear selected filters
    const filterButtons = document.querySelectorAll('.filter-btn');

    filterButtons.forEach((button) => {
      button.classList.remove('selected');  // Reset visual feedback
    });

    // Show all products after clearing filters
    const products = document.querySelectorAll('.product');
    products.forEach((product) => {
      product.style.display = 'block';
    });
  });
});
